import { render, staticRenderFns } from "./TwoLevelsSelector.component.vue?vue&type=template&id=3582a361&scoped=true&lang=pug"
import script from "./TwoLevelsSelector.component.vue?vue&type=script&lang=ts"
export * from "./TwoLevelsSelector.component.vue?vue&type=script&lang=ts"
import style0 from "./TwoLevelsSelector.component.vue?vue&type=style&index=0&id=3582a361&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3582a361",
  null
  
)

export default component.exports